export default function updateClickTipsPage() {
    // move search bar into header
    let pageHeader = document.querySelector('.catalog-header');
    let searchContainer = document.querySelector('.search-container');
    let description = document.querySelector('.catalog-header h2');

    pageHeader.append(searchContainer);
    pageHeader.append(description);
}
